"use client";

import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";

interface AuthMethodPanelProps {
  heading: string;
  helperText: string;
  isLoading: boolean;
  onBack: () => void;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export function AuthMethodPanel({
  heading,
  helperText,
  isLoading,
  onBack,
  footer,
  children,
}: AuthMethodPanelProps) {
  return (
    <div className="space-y-3 sm:space-y-5 w-full">
      <div className="space-y-3 sm:space-y-4">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onBack}
          disabled={isLoading}
          className="-ml-2 gap-1 text-xs sm:text-sm text-ink-subtle h-7 sm:h-8"
          data-testid={authTestIds.BACK_TO_METHODS_BUTTON}
        >
          <ArrowLeft className="size-3.5" />
          Back
        </Button>

        <div className="text-center space-y-1">
          <h2 className="text-lg font-semibold text-foreground">{heading}</h2>
          <p className="text-sm text-muted-foreground">{helperText}</p>
        </div>

        {children}
      </div>

      {footer}
    </div>
  );
}
